import React from 'react';

export const PersonalInfoPage = React.lazy(() => import('@app/pages/PersonalInfoPage'));
export const SecuritySettingsPage = React.lazy(() => import('@app/pages/SecuritySettingsPage'));
export const UserDatatable = React.lazy(() => import('@app/components/user/UserDatatable'));
export const CreateUser = React.lazy(() => import('@app/components/user/Create/CreateUser'));
export const EditUser = React.lazy(() => import('@app/components/user/Create/EditUser'));
export const FirmDatatable = React.lazy(() => import('@app/components/firm/firm-datatable/FirmDatatable'));
export const FirmRegister = React.lazy(() => import('@app/components/firm/Register/FirmRegister'));
export const FirmEdit = React.lazy(() => import('@app/components/firm/Register/FirmEdit'));
export const EmployeeDatatable = React.lazy(
  () => import('@app/components/Employee/Employee-DataTable/EmployeeDatatable'),
);
export const EmployeeRegister = React.lazy(() => import('@app/components/Employee/EmployeeRegister/EmployeeRegister'));
export const EmployeeEdit = React.lazy(() => import('@app/components/Employee/EmployeeRegister/EmployeeEdit'));
export const Attendence = React.lazy(() => import('@app/components/Attendence/Attendence'));
export const Salary = React.lazy(() => import('@app/components/Salary/Salary'));
export const SalaryReport = React.lazy(() => import('@app/components/SalaryReport/SalaryReport'));
export const SafetyReport = React.lazy(() => import('@app/components/SafetyReport/SafetyReport'));
export const AdvanceReport = React.lazy(() => import('@app/components/AdvanceReport/AdvanceReport'));
export const AdttendenceeReport = React.lazy(() => import('@app/components/AttandenceReport/AttandenceReport'));

export const EmployeeSafety = React.lazy(() => import('@app/components/EmployeeSafety/View/EmployeeSafety'));
export const EmployeeSafetyRegister = React.lazy(
  () => import('@app/components/EmployeeSafety/Register/EmployeeSafetyRegister'),
);
export const EmployeeSafetyEdit = React.lazy(() => import('@app/components/EmployeeSafety/Edit/EmployeeSafetyEdit'));
export const Fileroom = React.lazy(() => import('@app/components/fileroom/Fileroom'));

export const EmployeeAdvance = React.lazy(() => import('@app/components/EmployeeAdvance/View/EmployeeAdvance'));
export const EmployeeAdvanceRegister = React.lazy(
  () => import('@app/components/EmployeeAdvance/Register/EmployeeAdvanceRegister'),
);

export const EmployeeAdvanceEdit = React.lazy(() => import('@app/components/EmployeeAdvance/Edit/EmployeeAdvanceEdit'));

export const Logout = React.lazy(() => import('./Logout'));
